import _ from 'lodash';

export const GetAccessCodesType = (operator = {}, type) => {
  return operator && operator.codes && operator.codes.accessCodes
    ? operator.codes.accessCodes.filter(code => code.type === type).map(co => co.identifier)
    : [];
};

export const GetCSVRowAccessCodesType = (row = {}, type = '') => {
  const lowerCaseKeysRow = Object.keys(row).reduce((acc, k) => ((acc[k.toLowerCase()] = row[k]), acc), {});
  return lowerCaseKeysRow[type.toLowerCase()] || '';
};

export const ArrayToString = (data = []) => (Array.isArray(data) ? data.join(', ').replace('_', ' ') : '');

export const isPrimaryUser = user => {
  return _.get(user, 'features', []).some(feature => feature.path === 'access.group_admin');
};
